import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram } from 'react-icons/fa6';
import styles from './Footer.module.css';
import logo from "./img/LogoOficialCPP.png";
import dadosNoticias from '../../BlogJson/db.json'; 

function Footer() { 

    const [noticias, setNoticias] = useState([]);

    useEffect(() => {
        const arrayNoticias = dadosNoticias.noticias;
        const dadosReversos = [...arrayNoticias].reverse();
        setNoticias(dadosReversos);
      }, []);

    const ultimasNoticias = [...noticias]
        .sort((a, b) => new Date(b["data-json:"]) - new Date(a["data-json:"]))
        .slice(0, 4);

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.section}>
                    <h3 className={styles.title}>Contato & Info</h3>
                    <div className={styles.infoList}>
                        <p>📧 <strong>Email:</strong><a href="mailto:Para faleconosco@cppcontabilidade.com.br" className={styles.emailLink}> faleconosco@cppcontabilidade.com.br</a></p>                        
                        <p>📞 <strong>Telefone: </strong><a href="tel:+551123650500" className={styles.phoneLink}>(11) 2365 - 0500</a></p>
                        <p>📱 <strong>WhatsApp: </strong><a href="https://wa.link/yztfoa" target="_blank" rel="noopener noreferrer" className={styles.whatsappLink}>(11) 2365 - 0500</a></p>                        
                        <p>📍 <strong>Localização:</strong> <a href="https://www.google.com/maps?cid=9022579318684121953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAEYASAB&hl=pt-BR&source=embed" target="_blank" rel="noopener noreferrer">Rua General Eloy Alfaro 24, Sala 2<br/> Vila Mariana, São Paulo - SP, 04139 - 060</a></p>
                        <p>🕒 <strong>Horário:</strong> Seg a Sex, 08h às 18h</p>
                    </div>
                </div>

                <div className={styles.section}>
                    <h3 className={styles.title}>Nossos Serviços</h3>
                    <nav className={styles.navLinks}>
                        <Link to="/servico/gestao-contabil" className={styles.link}>Gestão Contábil</Link>
                        <Link to="/servico/gestao-de-empresas" className={styles.link}>Gestão de Empresas</Link>
                        <Link to="/servico/gestao-trabalhista-rh" className={styles.link}>Gestão Trabalhista & RH</Link>
                        <Link to="/servico/planejamento-tributario" className={styles.link}>Planejamento Tributário</Link>
                        <Link to="/servico/imposto-de-renda" className={styles.link}>Imposto de Renda</Link>
                        <Link to="/servico/servicos-complementares" className={styles.link}>Serviços Complementares</Link>
                    </nav>
                </div>

               <div className={styles.section}>
                    <h3 className={styles.title}>Últimas do Blog</h3>
                    <ul className={styles.blogList}>
                        {ultimasNoticias.map(noticia => (
                            <li key={noticia.id}>
                                <Link to={noticia.link} className={styles.link}>
                                    {noticia.titulo}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    <div className={styles.logoAndSelosWrapper}>
                        <div className={styles.footerLogoContainer}>
                            <img src={logo} alt="Logo CPP" className={styles.footerLogo} />
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.socialSection}>
                <a href="https://www.facebook.com/people/CPP-Contabilidade/61570612839057/?locale=pt_BR" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Facebook">
                    <FaFacebookF />
                </a>
                <a href="https://www.instagram.com/cppcontabilidade" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Instagram">
                    <FaInstagram />
                </a>
                {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="X (Twitter)">
                    <FaXTwitter />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="LinkedIn">
                    <FaLinkedinIn />
                </a> */}
            </div>

            <div className={styles.bottomBar}>
                <p>&copy; {new Date().getFullYear()} Todos os direitos reservados, CPP Contabilidade | <Link to="/termos" className={styles.linkFooter}>Termos de Uso</Link> & <Link to="/privacidade" className={styles.linkFooter}>Política de Privacidade</Link>.</p>
            </div>
        </footer>
    );
}

export default Footer;